import produce, { Draft } from 'immer';
import {
    ExperiencesState,
    ExperiencesAction,
    ExperiencesActions,
} from './types';

export const initialState: ExperiencesState = {
    memberGroupExperiences: null,
};

export const experiencesReducer = (
    state: ExperiencesState = initialState,
    action: ExperiencesActions
): ExperiencesState =>
    produce<ExperiencesState>(state, (draft: Draft<ExperiencesState>) => {
        switch (action.type) {
            case ExperiencesAction.SET_MEMBER_GROUP_EXPERIENCES:
                draft.memberGroupExperiences = action.payload.experiences;
                break;

            default:
                break;
        }
    });

export default experiencesReducer;
